import { useState } from 'react'
import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'
import { useNavigate } from 'react-router-dom'
import { CampaignForm } from '../components/CampaignForm'
import { Loading } from '../components/ui/Loading'
import { CampaignAPI } from '../api/CampaignAPI'

export const CampaignConfig = () => {
    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate()

    const fetchQuotes = (title, aiPrompt) => {
        setIsLoading(true)
        CampaignAPI.createQuoteGroup(title, aiPrompt)
            .then((response) => {
                navigate('/merchant/campaign_builder', {
                    state: {
                        messages: response.data.results,
                        title: response.data.title,
                        id: response.data.id,
                    },
                })
            })
            .catch((e) => console.log(e))
    }

    if (isLoading) {
        return <Loading message="Generating content..." />
    }

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography level="h2" color="neutral">
                Create Quote Campaign
            </Typography>
            <CampaignForm onSubmit={fetchQuotes} />
        </Box>
    )
}
